'use client'
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { AppContextProvider } from '@/contexts/AppContext';
export default function AppPages({
  children,
}: {
  children: React.ReactNode
}) {


  

  return (
        <div className={`dharmayana-web-app `}>
          <AppContextProvider>
            <Header />
            {children}
            <Footer />
          </AppContextProvider>
        </div>

  )
}

